import React from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { Button } from 'reactstrap';

import { Map } from 'immutable';

import printUnitTicketCargo from '../../../../utils/printers/UnitCargoTicket';

import { flagPrintCargo } from '../../../../actions';

const PrintUnitCargoTicketButton = ({
  cargoItemDetail,
  dispatchFlagPrintCargo,
  print,
}) => {
  const printUnitCargoTicket = async () => {
    dispatchFlagPrintCargo(true);

    await printUnitTicketCargo(
      typeof cargoItemDetail === 'object'
        ? cargoItemDetail.toJSON()
        : cargoItemDetail,
    );

    setTimeout(() => {
      dispatchFlagPrintCargo(false);
    }, 4000);
  };

  return (
    <Button
      color="light"
      className="border"
      onClick={printUnitCargoTicket}
      disabled={print}
    >
      <i className={`fa ${print ? 'fa-spinner' : 'fa-print'}`} /> Imprimir
      ticket
    </Button>
  );
};

PrintUnitCargoTicketButton.propTypes = {
  cargoItemDetail: PropTypes.instanceOf(Map).isRequired,
  dispatchFlagPrintCargo: PropTypes.func.isRequired,
  print: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ CargoUnit }) => ({
  print: CargoUnit.Cargo.getIn(['current', 'print']),
});

const mapDispatchToProps = {
  dispatchFlagPrintCargo: flagPrintCargo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrintUnitCargoTicketButton);
